import autocomplete from 'autocomplete.js';
import algoliasearch from 'algoliasearch/lite';
// import { debounced } from '../utils';

const initAutocomplete = () => {
  const env = document.body.dataset.env;
  const lang = document.body.dataset.lang.substr(0,2);
  let aroundMeTranslation = '';
  let noResultTranslation = '';

  let prefix = '';
  // if(env === 'localhost') {
  //   prefix = 'localhost_';
  // }
  // else if (env === 'staging') {
  //   prefix = 'staging_';
  // } else if (env === 'demo') {
  //   prefix = 'demo_';
  // }

  const client = algoliasearch("AK7I6BLE3J", "6b23703cf5bc843f0015aa31634bdeef");
  // const experiences = client.initIndex(prefix + 'experiences_' + lang);
  // const cities = client.initIndex(prefix + 'cities_' + lang);
  const hosts = client.initIndex(prefix + 'hosts_' + lang);
  const appellations = client.initIndex(prefix + 'appellations_' + lang);
  const regions = client.initIndex(prefix + 'regions_' + lang);
  const countries = client.initIndex(prefix + 'countries_' + lang);
  // const searchbar = document.getElementById('search-bar');
  const aaContainer = document.getElementById("aa-input-container");

  const searchBarSubmit = document.querySelector(".searchBarSubmit");
  const optionsHosts = {
    hitsPerPage: 3,
    // numericFilters: ['experiences_count_raw > 0'],
  };

  const aaInput = document.querySelector(".aa-search-input");
  if(aaInput){
    aroundMeTranslation = aaInput.dataset.aroundMe;
    noResultTranslation = aaInput.dataset.noResult;
  }

  const allInputLat = document.querySelectorAll('input[name=lat]');
  const allInputLng = document.querySelectorAll('input[name=lng]');
  const allInputZoom = document.querySelectorAll('input[name=zoom]');

  //marker placed when clicking on a search bar result
  var markerPlacedBySearch;

  document.addEventListener("click", function(e){
    const onSearchPage = document.body.dataset.controller === 'Search';
    if(e.target && e.target.classList.contains('aroundMe') && !onSearchPage){
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (pos) {
          // aaInput.value = aaInput.dataset.aroundMeText;
          // _this.lat.value = pos.coords.latitude;
          // _this.lng.value = pos.coords.longitude;
          // _this.zoom.value = 12;
          window.location.assign(aaInput.dataset.aroundMeUrl.replace("setLat", pos.coords.latitude).replace("setLng", pos.coords.longitude));
        });
      }
    }
  });

  var searchAutocomplete = autocomplete('.aa-search-input', {
    debug: false,
    // appendTo: '#search-bar',
    hint: true,
    templates: {
      footer: `
        <div class="aroundMe cursor-pointer border-t trigger-around-me">
          <span class="text-red text-center font-normal py-5 aroundMe block">${aroundMeTranslation ? aroundMeTranslation : 'See what\'s near me'}</span>
        </div>
      `,
      header: '',
      empty: `
        <div>
          <span class="text-base text-muted text-center font-normal py-5">${noResultTranslation}</span>
        </div>
      `,
    }
  }, [
//     {
//       source: autocomplete.sources.hits(experiences, { hitsPerPage: 3 }),
//       displayKey: 'name',
//       templates: {
//         // header: '<div class="aa-suggestions-category">Experiences</div>',
//         suggestion(suggestion) {
//           return `
//             <a href="${suggestion.url}" class="text-sm md:text-base flex items-center justify-start text-black">
//                 <img src="${suggestion.media}" alt="" class="w-10 h-10 rounded object-cover mr-3">
//                 <div class="flex flex-col">
//                     <span class="text-md font-semibold">${suggestion._highlightResult.name.value}</span>
//                     <p class="text-muted text-sm">Experience</p>
//                 </div>
// <!--                <span class="text-xs bg-green px-3 py-2 text-black rounded-lg ml-auto">Available today</span>-->
//             </a>
//             `
//         },
//       }
//     },
    {
      source: autocomplete.sources.hits(countries, { hitsPerPage: 2 }),
      displayKey: 'name',
      templates: {
        // header: '<div class="aa-suggestions-category">Hosts</div>',
        suggestion(suggestion) {
          let countryTranslation = aaInput ? aaInput.dataset.country : 'Country';
          let html = `
            <div class="text-sm md:text-base flex items-center justify-start text-black w-full">
              <div class="w-10 h-10 rounded-lg mr-3 bg-gray-100 border border-gray-200 flex flex-shrink-0 items-center justify-center">
                <i class="icon icon-location"></i>
              </div>
              <div class="flex flex-col mr-2 name-type-wrapper">
                  <span class="text-md font-semibold">${suggestion._highlightResult.name.value}</span>
                  <p class="text-muted text-sm">${countryTranslation}</p>
              </div>
            `;

          if(suggestion.experiences > 0)
            html += `<span class="text-muted ml-auto flex-shrink-0 hidden sm:block">${suggestion.experiences_count}</span>`;

          html += `</div>`;

          return html;
        }
      }
    },
    {
      source: autocomplete.sources.hits(regions, { hitsPerPage: 3 }),
      displayKey: 'name',
      templates: {
        // header: '<div class="aa-suggestions-category">Hosts</div>',
        suggestion(suggestion) {
          let regionTranslation = aaInput ? aaInput.dataset.region : 'Region';
          let html = `
                  <div class="text-sm md:text-base flex items-center justify-start text-black w-full">
                    <div class="w-10 h-10 rounded-lg mr-3 bg-gray-100 border border-gray-200 flex flex-shrink-0 items-center justify-center">
                      <i class="icon icon-location"></i>
                    </div>
                    <div class="flex flex-col mr-2 name-type-wrapper">
                        <span class="text-md font-semibold">${suggestion._highlightResult.name.value}</span>
                        <p class="text-muted text-sm">${regionTranslation}</p>
                    </div>
                  `;

          if(suggestion.experiences > 0)
            html += `<span class="text-muted ml-auto flex-shrink-0 hidden sm:block">${suggestion.experiences_count}</span>`;

          html += `</div>`;

          return html;
        }
      }
    },
    {
      source: autocomplete.sources.hits(hosts, optionsHosts),
      displayKey: 'name',
      templates: {
        suggestion(suggestion) {
          let hostTranslation = aaInput ? aaInput.dataset.host : 'Host';
          let html = `
            <a href="${suggestion.url}" class="text-sm md:text-base flex items-center justify-start text-black w-full">
                <img src="${suggestion.media_cdn_url}/cover=60x60" alt="" class="w-10 h-10 rounded object-cover mr-3">
                <div class="flex flex-col mr-2 name-type-wrapper">
                    <span class="text-md font-semibold">${suggestion._highlightResult.name.value}</span>
                    <p class="text-muted text-sm">${hostTranslation}</p>
                </div>
            `;

          if(suggestion.experiences_count_raw > 0)
            html += `<span class="text-muted ml-auto flex-shrink-0 hidden sm:block">${suggestion.experiences_count}</span>`;

          html += `</a>`;

          return html;
        }
      }
    },
    {
      source: function(query, callback){
        fetch(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json?access_token=pk.eyJ1Ijoid2luYWxpc3QiLCJhIjoiY2p0azd3b2Q5MTQzMjN5bzZidmU5cDF6biJ9.65pAPF4tbn5Geqg7JhvCFQ&limit=3&country=FR,IT,ES,PT,DE,CH&types=place,address,poi`
        )
        .then((response) => response.json())
        .then((result) => {
          callback(result.features);

          const mapboxDatasets = document.querySelectorAll('.aa-dataset-mapbox');
          if(mapboxDatasets){
            mapboxDatasets.forEach(dataset => {
              dataset.classList.remove('hidden');
            });
          }

          //Hide addresses and POI if there are no spaces
          const addressesSuggestions = document.querySelectorAll('.algolia-autocomplete:not(.show-addresses) .address, .algolia-autocomplete:not(.show-addresses) .poi');
          if(addressesSuggestions){
            addressesSuggestions.forEach(suggestion => {
              suggestion.parentNode.classList.add('hidden');
            });

            const mapboxDataset = document.querySelectorAll('.algolia-autocomplete:not(.show-addresses) .aa-dataset-mapbox');
            mapboxDataset.forEach(dataset => {
              const notHiddenSuggestions = dataset.querySelectorAll('.aa-suggestion:not(.hidden)');
              if(notHiddenSuggestions.length === 0){
                dataset.classList.add('hidden');
              }
            });
          }
        });
      },
      debounce: 500,
      name: 'mapbox',
      displayKey: function(suggestion) {
        return suggestion.place_name;
      },
      templates: {
        suggestion(suggestion) {
          return `
            <div class="text-sm md:text-base flex items-center justify-start text-black w-full ${suggestion.place_type[0]}">
              <div class="w-10 h-10 rounded-lg mr-3 bg-gray-100 border border-gray-200 flex flex-shrink-0 items-center justify-center">
                <i class="icon icon-location"></i>
              </div>
              <div class="flex flex-col name-type-wrapper">
                <span class="text-md font-semibold">${suggestion.place_name}</span>
              </div>
            </div>
          `;
        }
      }
    },
    // {
    //   source: autocomplete.sources.hits(cities, { hitsPerPage: 3 }),
    //   displayKey: 'name',
    //   name: 'cities',
    //   templates: {
    //     // header: '<div class="aa-suggestions-category">Hosts</div>',
    //     suggestion(suggestion) {
    //       let cityTranslation = aaInput ? aaInput.dataset.city : 'City';
    //       return `
    //         <div class="text-sm md:text-base flex items-center justify-start text-black">
    //             <i class="icon icon-location ml-2 mr-4"></i>
    //             <div class="flex flex-col">
    //                 <span class="text-md font-semibold">${suggestion._highlightResult.name.value}</span>
    //                 <p class="text-muted text-sm">${cityTranslation}</p>
    //             </div>
    //         </div>
    //         `;
    //     }
    //   }
    // },
    {
      source: autocomplete.sources.hits(appellations, { hitsPerPage: 3 }),
      displayKey: 'name',
      name: 'appellations',
      templates: {
        // header: '<div class="aa-suggestions-category">Hosts</div>',
        suggestion(suggestion) {
          let appellationTranslation = aaInput ? aaInput.dataset.appellation : 'Appellation';
          return `
            <div class="text-sm md:text-base flex items-center justify-start text-black w-full">
              <div class="w-10 h-10 rounded-lg mr-3 bg-gray-100 border border-gray-200 flex flex-shrink-0 items-center justify-center">
                <i class="icon icon-location"></i>
              </div>
              <div class="flex flex-col name-type-wrapper">
                  <span class="text-md font-semibold">${suggestion._highlightResult.name.value}</span>
                  <p class="text-muted text-sm">${appellationTranslation}</p>
              </div>
            </div>
            `;
        }
      }
    }
    // {
    //   source: autocomplete.sources.hits(experiences, { hitsPerPage: 3 }),
    //   displayKey: 'name',
    //   name: 'experiences',
    //   templates: {
    //     suggestion(suggestion) {
    //       let experienceTranslation = aaInput ? aaInput.dataset.experience : 'Experience';
    //       let html = `
    //         <a href="${suggestion.url}" class="text-sm md:text-base flex items-center justify-start text-black">
    //             <img src="${suggestion.cover_cdn_url}/cover=60x60" alt="" class="w-10 h-10 rounded object-cover mr-3">
    //             <div class="flex flex-col">
    //                 <span class="text-md font-semibold">${suggestion._highlightResult.name.value}</span>
    //                 <p class="text-gray-500 text-sm">${suggestion.host.name}</p>
    //                 <p class="text-muted text-sm">${experienceTranslation}</p>
    //             </div>
    //         `;

    //       html += `</a>`;

    //       return html;
    //     }
    //   }
    // },
  ]).on('autocomplete:selected autocomplete:autocompleted', function(event, suggestion, dataset, context) {
    // check if region or city
    // if(suggestion.objectID.includes('cities') || suggestion.objectID.includes('regions')) {
    // set inputs hidden
    // if(searchbar) {

    //If it's an api call from mapbox
    if(suggestion.hasOwnProperty('geometry')){
      if(allInputLat) {
        allInputLat.forEach(input => {
          input.value = suggestion.geometry.coordinates[1]; //lat
        });
      }
      if(allInputLng) {
        allInputLng.forEach(input => {
          input.value = suggestion.geometry.coordinates[0]; //lng
        });
      }
      if(allInputZoom) {
        allInputZoom.forEach(input => {
          input.value = 12;
        });
      }

      if(window.map){
        mapIsFlying = true;
        map.flyTo({
          center: [suggestion.geometry.coordinates[0], suggestion.geometry.coordinates[1]],
          zoom: 12,
          speed: 2.5
        });

        if(markerPlacedBySearch)
          markerPlacedBySearch.remove();

        let div = document.createElement('div');
        div.className = 'search-result-marker';
        markerPlacedBySearch = new mapboxgl.Marker({
          element: div
        })
        .setLngLat([suggestion.geometry.coordinates[0], suggestion.geometry.coordinates[1]])
        .addTo(map);
      }
    }
    else if(suggestion.hasOwnProperty('_geoloc') && window.map){
      mapIsFlying = true;
      map.flyTo({
        center: [suggestion._geoloc.lng, suggestion._geoloc.lat],
        zoom: suggestion.zoom ?? 12
      });

      if(markerPlacedBySearch)
        markerPlacedBySearch.remove();

      // let div = document.createElement('div');
      // div.className = 'search-result-marker';
      // markerPlacedBySearch = new mapboxgl.Marker({
      //   element: div
      // })
      // .setLngLat([suggestion._geoloc.lng, suggestion._geoloc.lat])
      // .addTo(map);
    }
    // }

    // if(aaContainer && !aaContainer.classList.contains("hidden")){
    //   if(suggestion.objectID.includes('regions')){
    //     window.location.assign(aaContainer.dataset.regionUrl.replace("%slug%", suggestion.slug));
    //     return;
    //   }
    //   else if(suggestion.objectID.includes('cities')){
    //     window.location.assign(aaContainer.dataset.cityUrl.replace("%slug%", suggestion.slug));
    //     return;
    //   }

    //   const form = aaContainer.querySelector("form");
    //   if(form){
    //     form.submit();
    //   }
    // }
    if(typeof(aaContainer) !== 'undefined' && !event.target.classList.contains('searchBarHome') && !window.hasOwnProperty('map')){
      if(suggestion.hasOwnProperty('url')){
        window.location.assign(suggestion.url);
      }
      else{
        let url = aaContainer.dataset.urlSearch
        .replace('setlat', suggestion.geometry.coordinates[1])
        .replace('setlng', suggestion.geometry.coordinates[0]);

        window.location.assign(url);
      }
    }
    // }
    // return;
    // }

    // Do nothing on click, as the browser will already do it
    if (context.selectionMethod === 'click') {
      if(searchBarSubmit){
        searchBarSubmit.disabled = false;
      }
      return;
    }
    // Change the page, for example, on other events
    // window.location.assign(suggestion.url);
  });

  // if(aaContainer){
  //   const inputs = aaContainer.querySelectorAll(".aa-search-input");
  //   if(inputs){
  //     inputs[inputs.length-1].addEventListener("keyup", function(e){
  //       if (e.keyCode === 13) {
  //         const form = aaContainer.querySelector("form");
  //         if(form){
  //           form.submit();
  //         }
  //       }
  //     });
  //   }
  // }

  window.searchAutocomplete = searchAutocomplete;

  const aaInputs = document.querySelectorAll(".aa-search-input");
  aaInputs.forEach(function(input){
    input.addEventListener('keyup', function(){
      let length = input.value.length;
      if(length >= 4){
        input.parentNode.classList.add('show-appellations'/*, 'show-experiences'*/);
      } else {
        input.parentNode.classList.remove('show-appellations'/*, 'show-experiences'*/);
      }

      if(input.value.indexOf(' ') !== -1){
        input.parentNode.classList.add('show-addresses');
      } else {
        input.parentNode.classList.remove('show-addresses');
      }
    });
  });

};

export { initAutocomplete };
